<template>

    <div class="login-oauth">
        <page-loader ref="loader"></page-loader>
        <div class="steps">{{ currentStep }} / {{ totalSteps }}</div>
        <modal-error-provider ref="MEP" :email="emailError"  @close="errorPopupClosed"></modal-error-provider>
        <modal-login-long-fail ref="MLLF" @close="errorPopupClosed"></modal-login-long-fail>
        <modal-outlook-invalid-credentials ref="MOIC" :simple="true" @close="errorPopupClosed"></modal-outlook-invalid-credentials>

    </div>

</template>

<script>



import Auth from '../modules/auth'
// import SessionStorage from '@/helpers/sessionStorage'
import Login from '../modules/login'
import OAuthMicrosoft from '../modules/o-auth/microsoft'

import PageLoader from '../components/PageLoader'
import ModalErrorProvider from '../components/modal/ModalErrorProvider'
import ModalLoginLongFail from '../components/modal/ModalLoginLongFailed'
import ModalOutlookInvalidCredentials from '../components/modal/ModalOutlookInvalidCredentials'


export default {

    name: 'login-o-auth-redirect',
    components: {
        PageLoader,
        ModalErrorProvider,
        ModalLoginLongFail,
        ModalOutlookInvalidCredentials
    },

    data() {
        return {
            currentStep: 1,
            totalSteps: 3,
            emailError: '',
            provider: 'microsoft'
        }
    },

    async mounted() {

        await this.initData()

    },

    methods: {

        currentStepIncrement() {
            this.currentStep++
        },

        errorPopupClosed() {
            this.$router.push({path: '/'})
        },


        async initData() {
            try {

                this.currentStepIncrement()
                this.$refs.loader.start()

                const {oAuthCodeVerifier, email} = OAuthMicrosoft.getOAuthStep1Data()
                const oAuthCode = this.$route.query.code
                const state = this.$route.query.state

                if (state === 'step1') {
                    // Connect the oauth account to Cleanfox/Foxbrain using a refresh token
                    const connectResult = await Auth.connect(this, email, undefined, this.provider, {oAuthCode, oAuthCodeVerifier})

                    this.currentStepIncrement()
                    Login.postConnectRoute(this, this.provider, connectResult)
                    this.$refs.loader.stop()
                } else {
                    console.error('LoginOAuthRedirect: Error during login-o-auth state:', state)
                    this.$refs.loader.stop()
                    this.$refs.MOIC.open()
                }
            } catch (error) {
                console.error('LoginOAuthRedirect: Error during login-o-auth', error)
                this.$refs.loader.stop()
                this.$refs.MOIC.open()
            }
            this.$refs.loader.stop()

        }
    }
}
</script>

<style lang="scss" scoped>

.steps {
    font-size: smaller;
    margin-top: auto;
    margin-bottom: auto;
}


</style>